module.exports = __webpack_public_path__ + "img/delete.4223e776.svg";